export const optionsOH = [
  {
    value: 8,
    title: 'START - Mensuel',
    text: "Pour démarrer sereinement dans l'immobilier",
  },
  {
    value: 9,
    title: 'START - Annuel',
    text: "Pour démarrer sereinement dans l'immobilier",
  },
  {
    value: 5,
    title: 'FIRST',
    text: 'Notre pack le plus populaire : le meilleur des deux mondes',
  },
  {
    value: 6,
    title: 'STANDARD',
    text: 'Pour maximiser la visibilité de tes annonces',
  },
  {
    value: 7,
    title: 'PREMIUM',
    text: "Pour les professionnels de l'immobilier",
  },
];

export const optionsCAPI = [
  {
    value: 6,
    title: 'Pack ESSENTIEL - 2024',
    text: 'Tous les outils essentiels pour démarrer avec un engagement financier mesuré',
  },
  {
    value: 7,
    title: 'Pack INTEGRAL - 2024',
    text: "L'intégralité des outils pour démarrer avec une visibilité maximale",
  },
  {
    value: 8,
    title: 'Pack INTEGRAL COMMERCE - 2024',
    text: 'Tous les outils pour les spécialistes Commerce & Entreprises avec une visibilité maximale',
  },
  {
    value: 9,
    title: 'Pack INTEGRAL NEUF - 2024',
    text: 'Tous les outils pour les spécialistes Neuf avec une visibilité maximale',
  },
  {
    value: 10,
    title: 'Pack ELITE - 2024',
    text: 'Toutes les solutions Capifrance avec une visibilité maximale et une performance récompensée',
  },
  {
    value: 11,
    title: 'Pack ESSENTIEL - 2025',
    text: 'Tous les outils essentiels pour démarrer avec un engagement financier mesuré',
  },
  {
    value: 12,
    title: 'Pack INTEGRAL - 2025',
    text: "L'intégralité des outils pour démarrer avec une visibilité maximale",
  },
  {
    value: 13,
    title: 'Pack INTEGRAL COMMERCE - 2025',
    text: 'Tous les outils pour les spécialistes Commerce & Entreprises avec une visibilité maximale',
  },
  {
    value: 14,
    title: 'Pack INTEGRAL NEUF - 2025',
    text: 'Tous les outils pour les spécialistes Neuf avec une visibilité maximale',
  },
  {
    value: 15,
    title: 'Pack ELITE - 2025',
    text: 'Toutes les solutions Capifrance avec une visibilité maximale et une performance récompensée',
  },
];
